import { withRouter } from 'react-router-dom'
import { isExternalAuth } from '../../cw_center/external-auth'
import { initCWTracks } from '../../cw_center/init-cwtracks'
import { useEffect } from 'react'
import Cookies from 'js-cookie'
import SkeltonSpinnerLoading from '../../components/SkeltonSpinnerLoading'

const Affiliate = (props: any) => {

    useEffect(() => {
        if (!isExternalAuth()) {
            props.history.push('/dashboard');
        } else {
            try {
                const urlSearchParams = new URLSearchParams(location.search);
                const utmParams = urlSearchParams.get("utm_content") || ''
                if (utmParams) {
                    Cookies.set('utm_content', utmParams, { expires: 30, sameSite: "none", secure: true, path: "/" })
                }
            } catch (error) {
                console.error('Error setting utm_content:', error)
            }
            initCWTracks();
        }
    }, [])

    return <SkeltonSpinnerLoading />
}

export default withRouter(Affiliate)